var map = {
	"./jak1/boggy-reflections_2022-01-10.png": "bafc",
	"./jak1/can-save-and-load_2022-01-11.png": "ddc0",
	"./jak1/too-much-fog_2022-01-10.png": "0ed2",
	"./jak1/videos": "0311",
	"./jak1/videos.json": "0311"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a531";